import { render } from "./SelectDropdown.vue?vue&type=template&id=768a7d72&scoped=true&ts=true"
import script from "./SelectDropdown.vue?vue&type=script&lang=ts"
export * from "./SelectDropdown.vue?vue&type=script&lang=ts"

import "./select-input.scss?vue&type=style&index=0&id=768a7d72&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768a7d72"]])

export default __exports__